import { useSelector } from "react-redux"

function Toast() {

    const toast = useSelector((state) => state.toast);
    return (
        <div className={`transition-all duration-200  ${toast.visible ? "opacity-100" : "opacity-0"}`}>
            <div className="fixed top-4 left-1/2 -translate-x-1/2 z-[300]">
                <div className=" max-w-xs bg-white border rounded-md shadow-lg dark:bg-gray-800 dark:border-gray-700" role="alert">
                    <div className="flex p-4">
                        <div className="flex-shrink-0">
                            <svg className={`h-4 w-4 text-${toast.type === 'success' ? "green" : "red"}-500 mt-0.5`} xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                <path d={toast.type === 'success' ? "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" : "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z"} />
                            </svg>
                        </div>
                        <div className="ml-3">
                            <p className="text-sm text-gray-700 dark:text-gray-400">
                                {toast.message}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default Toast